/* eslint-disable react/destructuring-assignment */
import cn from 'classnames'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import LabelWrapper from '../LabelWrapper'

class Switch extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { isChecked: props.isChecked }
    this.onChecked = this.onChecked.bind(this)
  }

  onChecked(isChecked) {
    this.setState({ isChecked }, () => {
      this.props.onChecked(isChecked)
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isChecked !== this.state.isChecked) {
      this.setState({ isChecked: nextProps.isChecked })
    }
  }

  render() {
    const {
      className,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      errorText,
      fullWidth,
      helperText,
      id,
      isChecked,
      isDisabled,
      justify,
      label,
      customLabel,
      isLabelInline,
      isRequired,
      isToolTip,
      multipleFields,
      notWrapper,
      noWrap,
      onChecked,
      size,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      withBorder,
      withDivider,
      withLabels,
      ...rest
    } = this.props
    return (
      <ThemeProvider theme={theme}>
        <LabelWrapper
          className={className}
          customCol={customCol}
          customMargin={customMargin}
          customPadding={customPadding}
          customWidth={customWidth}
          disabled={isDisabled}
          errorText={errorText}
          fullWidth={fullWidth}
          helperText={helperText}
          id={id}
          justify={justify}
          label={label}
          isLabelInline={isLabelInline}
          isRequired={isRequired}
          isToolTip={isToolTip}
          multipleFields={multipleFields}
          notWrapper={notWrapper}
          noWrap={noWrap}
          spacing={spacing}
          toolTipIcon={toolTipIcon}
          toolTipIconColor={toolTipIconColor}
          toolTipIconSize={toolTipIconSize}
          toolTipPosition={toolTipPosition}
          toolTipText={toolTipText}
          withBorder={withBorder}
          withDivider={withDivider}
        >
          <SwitchWrap>
            {customLabel && customLabel}
            <SwitchWrapLabel size={size}>
              <Checkbox
                type="checkbox"
                className={cn({ 'has-label': withLabels })}
                checked={this.state.isChecked}
                disabled={isDisabled}
                onClick={event => this.onChecked(!!event.target.checked)}
              />
              <Toggle size={size} className={cn({ 'has-label': withLabels })} isDisabled={isDisabled} {...rest}>
                {withLabels && (
                  <>
                    <SwitchLabel className="on">On</SwitchLabel>
                    <SwitchLabel className="off">Off</SwitchLabel>
                  </>
                )}
              </Toggle>
            </SwitchWrapLabel>
          </SwitchWrap>
        </LabelWrapper>
      </ThemeProvider>
    )
  }
}

Switch.defaultProps = {
  className: '',
  isChecked: false,
  onChecked: f => f,
  size: 'small',
  withLabels: false,
}

const SwitchWrap = styled.div`
  display: inline-flex;
  height: 36px;
  align-items: center;
  label {
    display: block;
  }
`
const SwitchWrapLabel = styled.label`
  height: ${props => (props.size === 'small' ? '20px' : '36px')};
`

const Checkbox = styled.input`
  display: none;
`

const Toggle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  width: ${props => (props.size === 'small' ? '36px' : '66px')};
  height: ${props => (props.size === 'small' ? '20px' : '36px')};
  border-radius: ${props => (props.size === 'small' ? '16px' : '34px')};
  text-transform: ${props => props.size === 'large' && 'uppercase'};
  background-color: #9b9b9b;
  cursor: ${props => (props.isDisabled ? 'not-allowed' : 'pointer')};
  transition: all 0.1s ease-in-out;
  z-index: 1;
  padding: 0 10px;
  opacity: ${props => props.isDisabled && '0.7'};
  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: ${props => (props.size === 'small' ? '2px' : '1px')};
    border-radius: ${props => (props.size === 'small' ? '16px' : '34px')};
    height: ${props => (props.size === 'small' ? '16px' : '34px')};
    transform: translate3d(0, 0, 0);
    transition: 0.2s cubic-bezier(0, 1.1, 1, 1.1);
  }
  &::before {
    z-index: -1;
    width: ${props => (props.size === 'small' ? '36px' : '66px')};
    right: ${props => (props.size === 'small' ? '2px' : '1px')};
    transform: scale(1);
  }
  &::after {
    z-index: 1;
    width: ${props => (props.size === 'small' ? '16px' : '34px')};
    left: ${props => (props.size === 'small' ? '2px' : '1px')};
    background: ${props => props.theme.colors.white};
  }
  &:hover {
    &::after {
      background: ${props => !props.isDisabled && props.theme.colors.lightGrey};
    }
  }
  .off {
    justify-self: flex-end;
  }
  .on {
    display: none;
  }
  input:checked + & {
    background-color: ${props => props.theme.colors.green};
    justify-content: flex-start;
    &::before {
      transform: scale(0);
    }
    &::after {
      transform: translate3d(${props => (props.size === 'small' ? '16px' : '30px')}, 0, 0);
    }
    > .off {
      display: none;
    }
    > .on {
      display: inline-block;
    }
  }
  &.has-label {
    width: ${props => (props.size === 'small' ? '56px' : '80px')};
    &::before {
      width: ${props => (props.size === 'small' ? '56px' : '80px')};
    }
  }
  input.has-label:checked + & {
    &::after {
      transform: translate3d(${props => (props.size === 'small' ? '36px' : '44px')}, 0, 0);
    }
  }
`

const SwitchLabel = styled.div`
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.typography.fontSizeSm};
  font-weight: ${props => props.theme.typography.fontWeightBolder};
`

export default Switch
